import { useLmsDropdownOptions } from '../addlms/option/LsmOption';
import { NormalContainerWithHeader, TopHeadSection } from '../../shared/components/student/NormalComponent';
import { postAddLsm } from '../../assets/nodeApi/postApi/postAdminApi';
import { useToaster } from '../../shared/utils/ToasterProvider';
import { Field, FieldArray, Form, Formik } from 'formik';
import * as Yup from 'yup';
import { IdAutoCompleteField } from '../../shared/components/formfields/IdAutoCompleteField';
import { AutoCompleteField } from '../../shared/components/formfields/AutoCompleteField';
import { Box, Button, Grid2, Typography } from '@mui/material';
import { Grid_Gap, Input_Width, Input_Width_LG } from '../../shared/constants';
import { useMutation } from '@tanstack/react-query';
import CustomDivider from '../../shared/utils/CustomDivider';
import SprintWrapper from '../../shared/components/admin/SprintWrapper';
import { TextFormField } from '../../shared/components/formfields/TextFormField';
import AddIcon from '@mui/icons-material/Add';




const AddQuestionBank = () => {
    const { showToaster } = useToaster();
    const {
        lmsGrade,
        lmsPublication,
        lmsLangauge,
        lmsBoard,
        lmsCourses,
        lmsCourseType,
    } = useLmsDropdownOptions(
        {
        gradeFilter: { status: true },
        boardFilter: { status: true },
        publicationFilter: { status: true },
        languagesFilter: { status: true },
 
        }
    );

    const validationSchema = Yup.object().shape({});
    const initialValues = {
        content: "",
        tlm: "",
        worksheets: "",
        classquestion: "",
        questions: [
            {
                question_type: "",
                mark: "",
                question: "",
                answer: ""
            }

        ]

    };



    const mutationAddLMS = useMutation({
        mutationFn: postAddLsm,
    });

    const handleSubmit = (values, { resetForm }) => {
        const payload = {
            languageId: Number(values.languageId),
            eventId: Number(values.eventId),
            course_type: values.course_type,
            boardId: Number(values.boardId),
            gradeId: Number(values.gradeId),
            publicationId: Number(values.publicationId),


        };

        mutationAddLMS.mutate(payload, {
            onSuccess: () => {
                showToaster("LMS Added successfully!", "", "success");
                resetForm();
            },
            onError: (err) => {
                showToaster(
                    err?.response?.data?.error || "Failed to Add LMS",
                    "",
                    "error"
                );
            },
        });
    };

    return (
        <NormalContainerWithHeader headerText={"Syllabus"}>
            <Typography>
                Create and organize syllabus details for better course planning
            </Typography>
            <CustomDivider />

            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                enableReinitialize
            >
                {({ values, resetForm }) => (
                    <Form>
                        <Grid2 container spacing={Grid_Gap}>
                            {/* 🔹 Common fields */}
                            <Grid2 children size={Input_Width_LG}>
                                <Field
                                    name="eventId"
                                    component={IdAutoCompleteField}
                                    options={lmsCourses.options}
                                    label="Course Name"
                                    isRequired={true}
                                    isLoading={lmsCourses.isLoading}
                                />
                            </Grid2>
                            <Grid2 children size={Input_Width_LG}>
                                <Field
                                    name="course_type"
                                    component={AutoCompleteField}
                                    options={lmsCourseType.options}
                                    label="Course Type"
                                    isRequired={true}
                                />
                            </Grid2>
                            <Grid2 children size={Input_Width_LG}>
                                <Field
                                    name="boardId"
                                    component={IdAutoCompleteField}
                                    options={lmsBoard.options}
                                    label="Board"
                                    isRequired={true}
                                    isLoading={lmsBoard.isLoading}
                                />
                            </Grid2>
                            <Grid2 children size={Input_Width_LG}>
                                <Field
                                    name="languageId"
                                    component={IdAutoCompleteField}
                                    options={lmsLangauge.options}
                                    label="Language"
                                    isRequired={true}
                                    isLoading={lmsLangauge.isLoading}
                                />
                            </Grid2>
                            <Grid2 children size={Input_Width_LG}>
                                <Field
                                    name="gradeId"
                                    component={IdAutoCompleteField}
                                    options={lmsGrade.options}
                                    label="Grade"
                                    isRequired={true}
                                    isLoading={lmsGrade.isLoading}
                                />
                            </Grid2>
                            <Grid2 children size={Input_Width_LG}>
                                <Field
                                    name="publicationId"
                                    component={IdAutoCompleteField}
                                    options={lmsPublication.options}
                                    label="Publications"
                                    isRequired={true}
                                    isLoading={lmsPublication.isLoading}
                                />
                            </Grid2>

                            <CustomDivider />


                        </Grid2>



                        <TopHeadSection headerText={"Add Questions & Answers"} />

                        <Typography mt={1.5}>
                            Add new questions to the question bank for future assessments
                        </Typography>

                        <CustomDivider />



                        <FieldArray name="questions">
                            {({ push: pushQuestion, remove: removeQuestion }) => (
                                <>
                                    {values?.questions?.map((_, qIndex) => (
                                        <>
                                            <SprintWrapper
                                                key={qIndex}
                                                headerText={`Question ${qIndex + 1}`}
                                                onDelete={() => removeQuestion(qIndex)}
                                                sx={{ backgroundColor: "#FBFDFF" }}
                                            >
                                                <Grid2 container spacing={Grid_Gap}>
                                                    <Grid2 children size={Input_Width_LG}>
                                                        <Field
                                                            name={`questions[${qIndex}].question_type`}
                                                            component={TextFormField}
                                                            label="Question Type"
                                                            isRequired={true}

                                                        />
                                                    </Grid2>
                                                    <Grid2 children size={Input_Width_LG}>
                                                        <Field
                                                            name={`questions[${qIndex}].mark`}
                                                            component={TextFormField}
                                                            label="Mark"
                                                            isRequired={true}

                                                        />
                                                    </Grid2>
                                                    <Typography my={1}>Add the question and respective answer here</Typography>
                                                    <Grid2 children size={12}>
                                                        <Field
                                                            name={`questions[${qIndex}].question`}
                                                            component={TextFormField}
                                                            label="Question"
                                                            isRequired={true}

                                                        />
                                                    </Grid2>
                                                    <Grid2 children size={12}>
                                                        <Field
                                                            name={`questions[${qIndex}].answer`}
                                                            component={TextFormField}
                                                            label="Answer"
                                                            isRequired={true}
                                                            multiline
                                                            rows={3}

                                                        />
                                                    </Grid2>

                                                </Grid2>
                                                <CustomDivider />



                                            </SprintWrapper>
                                        </>

                                    ))}
                                    <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                                        <Button
                                            startIcon={<AddIcon />}
                                            onClick={() =>
                                                pushQuestion({
                                                    question_type: "",
                                                    mark: "",
                                                    question: "",
                                                    answer: ""
                                                })
                                            }
                                            variant="contained"
                                        >
                                            Add Question
                                        </Button>
                                    </Box>
                                </>
                            )}

                        </FieldArray >

                        <Grid2 container spacing={Grid_Gap} mt={2}>
                            <Grid2 children size={Input_Width}>
                                <Button
                                    variant="outlined"
                                    type="button"
                                    onClick={() => resetForm()}
                                    fullWidth
                                >
                                    Reset
                                </Button>
                            </Grid2>
                            <Grid2 children size={Input_Width}>
                                <Button
                                    variant="contained"
                                    type="submit"
                                    fullWidth
                                    disabled={mutationAddLMS.isPending}
                                >
                                    {mutationAddLMS.isPending ? "Submitting" : "Submit"}
                                </Button>
                            </Grid2>
                        </Grid2>
                    </Form>
                )}
            </Formik>

            <CustomDivider />
            <CustomDivider />


        </NormalContainerWithHeader>
    );
};

export default AddQuestionBank;

